'use client';

import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { experiences } from '@/lib/data';
import { useActivityVisibility } from '@/hooks/useActivityVisibility';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import styles from './experiences.module.css';
import { BreadcrumbSchema } from '@/lib/schema';


/**
 * APEX EXPERIENCES INDEX PAGE
 *
 * Magazine-style layout showcasing curated experiences
 * Wine tours, Patagonia expeditions, helicopter tours, cultural journeys, wellness retreats
 */
export default function ExperiencesPage() {
  const t = useTranslations('experiences');
  const tCommon = useTranslations('common');
  const params = useParams();
  const locale = params.locale as string;
  const { isVisible } = useActivityVisibility();

  return (
    <>
      <BreadcrumbSchema items={[
        { name: tCommon('home'), href: `/${locale}/` },
        { name: t('index.title'), href: `/${locale}/experiences/` },
      ]} />
      <Header />
      <main className={styles.experiencesWrapper}>
        <section className={styles.experiencesIntro}>
          <span className={styles.label}>{t('index.label')}</span>
          <h1 className={styles.title}>{t('index.title')}</h1>
          <p className={styles.subtitle}>{t('index.subtitle')}</p>
        </section>

        <section className={styles.experiencesGrid}>
          {experiences.filter(e => isVisible(e.id, e.hidden)).map((experience, index) => (
            <a
              key={experience.id}
              href={`/${locale}/experiences/${experience.id}/`}
              className={styles.experienceItem}
              style={{ '--index': index } as React.CSSProperties}
            >
              <div className={styles.itemCard}>
                <div
                  className={styles.itemBg}
                  style={{ backgroundImage: `url(${experience.heroImage})` }}
                />
                <div className={styles.itemOverlay}>
                  <span className={styles.itemLocation}>{experience.location}</span>
                  <h3 className={styles.itemTitle}>{experience.title}</h3>
                  <p className={styles.itemDescription}>
                    {experience.description.substring(0, 120)}...
                  </p>
                  <span className={styles.itemLink}>{t('common.explore')}</span>
                </div>
              </div>
            </a>
          ))}
        </section>

        <section className={styles.ctaSection}>
          <h2 className={styles.ctaTitle}>{t('index.ctaTitle')}</h2>
          <p className={styles.ctaDescription}>{t('index.ctaDescription')}</p>
          <a href={`/${locale}/contact/`} className={styles.ctaButton}>
            {tCommon('contactUs')}
          </a>
        </section>
      </main>
      <Footer />
    </>
  );
}
